import { render } from "./ModalNotiSinLeerComponent.vue?vue&type=template&id=277183ff&scoped=true"
import script from "./ModalNotiSinLeerComponent.vue?vue&type=script&lang=js"
export * from "./ModalNotiSinLeerComponent.vue?vue&type=script&lang=js"

import "./ModalNotiSinLeerComponent.vue?vue&type=style&index=0&id=277183ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277183ff"]])

export default __exports__